export default __webpack_public_path__ + "static/media/canones.4c5a084e.png";